import { render } from "./MaterialLibrary.vue?vue&type=template&id=452a1f5e"
import script from "./MaterialLibrary.vue?vue&type=script&lang=js"
export * from "./MaterialLibrary.vue?vue&type=script&lang=js"

import "./MaterialLibrary.vue?vue&type=style&index=0&id=452a1f5e&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__